/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import MenuItem from '../MenuItem';
import { PartnersIcon, TemplatesIcon } from '../../../bombiix-icon';
import SettingUrl from './SettingUrl';

function SupplierUrl(props) {
  const { state, isMobileMenu } = props;
  const history = useHistory();
  const pathName = history.location.pathname;
  const isSupplierLoggedIn = state?.isSupplierLoggedIn;
  const [show, setShow] = useState(true);

  useEffect(() => {
    const checkUserRole = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (checkUserRole && checkUserRole?.role === 'Supplier') {
      setShow(false);
    }
  }, []);
  return !isSupplierLoggedIn && show ? (
    <ul>
      <MenuItem
        activeClassList={['suppliers', 'users', 'component-suppliers', 'supporting-docs']}
        pathName={pathName}
        linkTo="/suppliers"
        IconComponent={PartnersIcon}
        titleKey="SUPPLIER_DOCUMENT.SUPPLIERS"
        isMobileMenu={isMobileMenu}
      />

      <MenuItem
        activeClassList={['/supplier/templates']}
        pathName={pathName}
        linkTo="/supplier/templates"
        IconComponent={TemplatesIcon}
        titleKey="SUPPLIER_DOCUMENT.TEMPLATES"
        isMobileMenu={isMobileMenu}
      />
    </ul>
  ) : (
    <SettingUrl />
  );
}

export default SupplierUrl;
